<template>
    <div
        class="clip-left-corner-large relative row-span-3 grid grid-rows-subgrid gap-y-12 overflow-hidden p-4"
        :class="variant === 'light' ? 'text-bg bg-white' : 'bg-red-600 text-white'"
    >
        <img
            src="@/assets/images/statistics/pattern.svg"
            alt=""
            aria-hidden="true"
            class="pointer-events-none absolute right-0 bottom-0 size-[171px] max-w-none"
        />

        <h2
            :lang="$i18n.locale"
            class="font-title relative text-2xl leading-6 font-extrabold break-words hyphens-auto uppercase"
        >
            {{ title }}
        </h2>
        <div
            class="font-title relative text-center text-[30px] leading-[30px] font-extrabold uppercase"
            data-testid="stats-hero-value"
        >
            {{ value }}
        </div>
        <div class="relative text-xs leading-4 font-black tracking-[0.25px] uppercase">
            {{ footnote }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatsHeroTile',
    props: {
        title: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number],
            required: true,
        },
        footnote: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'red',
            validator: (value) => ['red', 'light'].includes(value),
        },
    },
}
</script>
